import { t } from 'i18next';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';

interface WasTextProps {
  amount: string;
}

export default function WasText({ amount }: WasTextProps) {
  return (
    <OverflowAwareText
      data-test-id="charge-was"
      sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}
    >
      {t('approvals.approve_charges.was', {
        amount,
        interpolation: { escapeValue: false },
      })}
    </OverflowAwareText>
  );
}
